import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LoaderService {
    private isShown = new BehaviorSubject<boolean>(false);
    private message = new BehaviorSubject<string>("");
    loaderState = this.isShown.asObservable();
    loaderMessage = this.message.asObservable();
    
    show(state: boolean, message?:string) {
      this.isShown.next(state);
      this.message.next(message);
    }
}


// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/services/loader.service.ts